import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const CtrlMenuDotsIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
      strokeWidth={strokeWidth}
    >
      <path
        d="M12.5 10.875H11.5C11.1548 10.875 10.875 11.1548 10.875 11.5V12.5C10.875 12.8452 11.1548 13.125 11.5 13.125H12.5C12.8452 13.125 13.125 12.8452 13.125 12.5V11.5C13.125 11.1548 12.8452 10.875 12.5 10.875Z"
        fill={color}
      />
      <path
        d="M12.5 18H11.5C11.1548 18 10.875 18.2798 10.875 18.625V19.625C10.875 19.9702 11.1548 20.25 11.5 20.25H12.5C12.8452 20.25 13.125 19.9702 13.125 19.625V18.625C13.125 18.2798 12.8452 18 12.5 18Z"
        fill={color}
      />
      <path
        d="M12.5 3.75H11.5C11.1548 3.75 10.875 4.02982 10.875 4.375V5.375C10.875 5.72018 11.1548 6 11.5 6H12.5C12.8452 6 13.125 5.72018 13.125 5.375V4.375C13.125 4.02982 12.8452 3.75 12.5 3.75Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

CtrlMenuDotsIcon.displayName = 'CtrlMenuDotsIcon';
